import React from 'react';
import style from './limitGame.css';
import { useSelector } from 'react-redux';

/**
 *
 * @type {React.NamedExoticComponent<{history?: *, content?: *}>}
 */
const LimitGame = React.memo( () => {
    const { localization: { content } } = useSelector( ( state ) => state );
    return (
        <section className={ style.pageWrapper }>
            <div className={ style.infoBlock }>
                <h1>{ content.reached_game_limit }</h1>
            </div>
        </section>
    );
} );

export default LimitGame;